import * as React from 'react';
import { FacebookProvider, Page } from 'react-facebook';

interface IProps {
    appId: string;
    url: string;
}

export const Facebook = ({ appId, url }: IProps) => (
    <FacebookProvider appId={appId}>
        <Page
            width="340"
            height="340"
            smallHeader={true}
            href={url}
            tabs="timeline"
            target="_top"
            showFacepile={false}
        />
    </FacebookProvider>
);